"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("../../components");
var antd_1 = require("antd");
var react_intl_1 = require("react-intl");
var form_item_1 = require("../form-item");
var RequirementsUtility_1 = require("../../../utils/RequirementsUtility");
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var mapi_1 = require("@unimaze/api-clients/lib/mapi");
exports.translationMessages = react_intl_1.defineMessages({
    paymentMethod_title: {
        id: "paymentMethod_title",
        defaultMessage: "Payment method",
    },
    paymentMethod_label: {
        id: "paymentMethod_label",
        defaultMessage: "Account number",
    },
    paymentMethod_labels_domesticTransfer_bankNo: {
        id: "paymentMethod_labels_domesticTransfer_bankNo",
        defaultMessage: "Bank no",
    },
    paymentMethod_labels_domesticTransfer_accountType: {
        id: "paymentMethod_labels_domesticTransfer_accountType",
        defaultMessage: "Account type",
    },
    paymentMethod_labels_domesticTransfer_accountNo: {
        id: "paymentMethod_labels_domesticTransfer_accountNo",
        defaultMessage: "Account no",
    },
    paymentMethod_labels_domesticTransfer_paymentReference: {
        id: "paymentMethod_labels_domesticTransfer_paymentReference",
        defaultMessage: "Payment reference",
    },
    paymentMethod_labels_icelandicClaim_bankNo: {
        id: "paymentMethod_labels_icelandicClaim_bankNo",
        defaultMessage: "Bank no",
    },
    paymentMethod_labels_icelandicClaim_claimNo: {
        id: "paymentMethod_labels_icelandicClaim_claimNo",
        defaultMessage: "Account no",
    },
    paymentMethod_labels_methods_undefined: {
        id: "paymentMethod_labels_methods_undefined",
        defaultMessage: "Undefined",
    },
    paymentMethod_labels_methods_mutuallyAgreed: {
        id: "paymentMethod_labels_methods_mutuallyAgreed",
        defaultMessage: "Mutually agreed",
    },
    paymentMethod_labels_methods_domesticTransfer: {
        id: "paymentMethod_labels_methods_domesticTransfer",
        defaultMessage: "Transfer",
    },
    paymentMethod_labels_methods_domesticClaim: {
        id: "paymentMethod_labels_methods_domesticClaim",
        defaultMessage: "Claim",
    },
    paymentMethod_rules_number: {
        id: "paymentMethod_rules_number",
        defaultMessage: "Please use only number characters"
    },
    paymentMethod_rules_Length: {
        id: "paymentMethod_rules_Length",
        defaultMessage: "{fieldName} must be between {min} and {max}"
    }
});
var PaymentMethod = function (props) {
    var paymentMeansType = props.formInstance.getFieldValue(["invoice", "paymentMeans", "type"]) ? props.formInstance.getFieldValue(["invoice", "paymentMeans", "type"]) : "NotSpecified";
    var initialPaymentMeansType = mapi_1.PaymentMeansType[paymentMeansType];
    var _a = react_1.useState(initialPaymentMeansType), paymentMethod = _a[0], setPaymentMethod = _a[1]; // PaymentMeansType.DomesticClaim);
    var domesticTransferFormFields = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Form.Item, { label: props.intl.formatMessage(exports.translationMessages.paymentMethod_label) },
            react_1.default.createElement(antd_1.Row, { gutter: [8, 0] },
                react_1.default.createElement(antd_1.Col, { span: 6 },
                    react_1.default.createElement(antd_1.Form.Item, { noStyle: true, 
                        // label={props.intl.formatMessage(translationMessages.paymentMethod_labels_domesticTransfer_bankNo)}
                        name: ["invoice", "paymentMeans", "domesticTransfer", "bankNumber"], rules: [
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_number),
                            },
                            {
                                min: 1,
                                max: 4,
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_Length, {
                                    fieldName: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_domesticTransfer_bankNo),
                                    min: 1,
                                    max: 4
                                }),
                            }
                        ] },
                        react_1.default.createElement(antd_1.Input, { placeholder: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_domesticTransfer_bankNo) }))),
                react_1.default.createElement(antd_1.Col, { span: 6 },
                    react_1.default.createElement(antd_1.Form.Item, { noStyle: true, 
                        // label={props.intl.formatMessage(translationMessages.paymentMethod_labels_domesticTransfer_accountType)}
                        name: ["invoice", "paymentMeans", "domesticTransfer", "accountTypeNumber"], rules: [{
                                required: true,
                                message: props.intl.formatMessage(form_item_1.translationMessages.formItem_required_errorMessage)
                            }] },
                        react_1.default.createElement(antd_1.Select, { placeholder: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_domesticTransfer_accountType), dropdownMatchSelectWidth: false },
                            react_1.default.createElement(antd_1.Select.Option, { value: "04" }, "04"),
                            react_1.default.createElement(antd_1.Select.Option, { value: "05" }, "05"),
                            react_1.default.createElement(antd_1.Select.Option, { value: "13" }, "13"),
                            react_1.default.createElement(antd_1.Select.Option, { value: "14" }, "14"),
                            react_1.default.createElement(antd_1.Select.Option, { value: "15" }, "15"),
                            react_1.default.createElement(antd_1.Select.Option, { value: "26" }, "26")))),
                react_1.default.createElement(antd_1.Col, { span: 12 },
                    react_1.default.createElement(antd_1.Form.Item, { noStyle: true, 
                        // label={props.intl.formatMessage(translationMessages.paymentMethod_labels_domesticTransfer_accountNo)}
                        name: ["invoice", "paymentMeans", "domesticTransfer", "accountNumber"], rules: [
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_number),
                            },
                            {
                                min: 1,
                                max: 6,
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_Length, {
                                    fieldName: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_domesticTransfer_accountNo),
                                    min: 1,
                                    max: 6
                                }),
                            }
                        ] },
                        react_1.default.createElement(antd_1.Input, { placeholder: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_domesticTransfer_accountNo) }))))),
        react_1.default.createElement(antd_1.Form.Item, { label: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_domesticTransfer_paymentReference), name: ["invoice", "paymentMeans", "domesticTransfer", "paymentIdentifier"], rules: [
                {
                    pattern: new RegExp("^[0-9]*$"),
                    message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_number),
                },
                {
                    max: 18,
                    message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_Length, {
                        fieldName: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_domesticTransfer_paymentReference),
                        min: 1,
                        max: 18
                    }),
                }
            ] },
            react_1.default.createElement(antd_1.Input, null)));
    var icelandicClaimFormFields = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Form.Item, { label: props.intl.formatMessage(exports.translationMessages.paymentMethod_label) },
            react_1.default.createElement(antd_1.Row, { gutter: [8, 0] },
                react_1.default.createElement(antd_1.Col, { span: 6 },
                    react_1.default.createElement(antd_1.Form.Item, { noStyle: true, 
                        // label={props.intl.formatMessage(translationMessages.paymentMethod_labels_icelandicClaim_bankNo)}
                        name: ["invoice", "paymentMeans", "domesticClaim", "bankNumber"], rules: [
                            {
                                required: true,
                                message: props.intl.formatMessage(form_item_1.translationMessages.formItem_required_errorMessage)
                            },
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_number),
                            },
                            {
                                min: 1,
                                max: 4,
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_Length, {
                                    fieldName: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_icelandicClaim_bankNo),
                                    min: 1,
                                    max: 4
                                }),
                            }
                        ] },
                        react_1.default.createElement(antd_1.Input, { placeholder: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_icelandicClaim_bankNo) }))),
                react_1.default.createElement(antd_1.Col, { span: 6 },
                    react_1.default.createElement(antd_1.Input, { disabled: true, value: 66 })),
                react_1.default.createElement(antd_1.Col, { span: 12 },
                    react_1.default.createElement(antd_1.Form.Item, { noStyle: true, 
                        // label={props.intl.formatMessage(translationMessages.paymentMethod_labels_icelandicClaim_claimNo)}
                        name: ["invoice", "paymentMeans", "domesticClaim", "accountNumber"], rules: [
                            {
                                required: true,
                                message: props.intl.formatMessage(form_item_1.translationMessages.formItem_required_errorMessage)
                            },
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_number),
                            },
                            {
                                min: 1,
                                max: 6,
                                message: props.intl.formatMessage(exports.translationMessages.paymentMethod_rules_Length, {
                                    fieldName: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_icelandicClaim_claimNo),
                                    min: 1,
                                    max: 6
                                }),
                            }
                        ] },
                        react_1.default.createElement(antd_1.Input, { placeholder: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_icelandicClaim_claimNo) }))))));
    var renderFormFields = function (payMthd) {
        switch (payMthd) {
            case mapi_1.PaymentMeansType.NotSpecified:
            case mapi_1.PaymentMeansType.MutuallyAgreed:
                return null;
            case mapi_1.PaymentMeansType.DomesticTransfer:
                return (domesticTransferFormFields);
            case mapi_1.PaymentMeansType.DomesticClaim:
                return (icelandicClaimFormFields);
            default:
                return null;
        }
    };
    var defaultPaymentMethods = [
        {
            key: mapi_1.PaymentMeansType.NotSpecified,
            name: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_methods_undefined) // "Undefined" "Óskilgreint"
        },
        {
            key: mapi_1.PaymentMeansType.MutuallyAgreed,
            name: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_methods_mutuallyAgreed) // "Mutually agreed" "Skv. samkomulagi"
        },
        {
            key: mapi_1.PaymentMeansType.DomesticTransfer,
            name: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_methods_domesticTransfer) // "Transfer"
        },
        {
            key: mapi_1.PaymentMeansType.DomesticClaim,
            name: props.intl.formatMessage(exports.translationMessages.paymentMethod_labels_methods_domesticClaim) // "Claim"
        }
    ];
    var getPaymentMeansTypeOptions = function (receiverRequirements) {
        var paymentMeansTypeFieldDefinition = RequirementsUtility_1.getFieldRequirements(receiverRequirements, ReceiverRequirements_1.AvailableFields["paymentMeans.type"]);
        if (paymentMeansTypeFieldDefinition
            && paymentMeansTypeFieldDefinition.hasOwnProperty("properties")
            && paymentMeansTypeFieldDefinition.properties.hasOwnProperty("values")
            && paymentMeansTypeFieldDefinition.properties.values) {
            return paymentMeansTypeFieldDefinition.properties.values.map(function (op) {
                return react_1.default.createElement(antd_1.Select.Option, { key: op.key, value: mapi_1.PaymentMeansType[op.key], title: op.name }, op.name);
            });
        }
        else {
            return defaultPaymentMethods.map(function (op) {
                return react_1.default.createElement(antd_1.Select.Option, { key: op.key, value: mapi_1.PaymentMeansType[op.key], title: op.name }, op.name);
            });
        }
    };
    return (react_1.default.createElement(components_1.ComponentContainer, { title: props.intl.formatMessage(exports.translationMessages.paymentMethod_title) },
        react_1.default.createElement(antd_1.Form.Item, { name: ["invoice", "paymentMeans", "type"] },
            react_1.default.createElement(antd_1.Select, { dropdownMatchSelectWidth: false, value: paymentMethod, onSelect: setPaymentMethod }, getPaymentMeansTypeOptions(props.receiverRequirements))),
        renderFormFields(paymentMethod)));
};
exports.default = react_intl_1.injectIntl(PaymentMethod);
